// Module
var code = `<ex-mono-occurrence-ecran mono-occurrence-options="vm.monoOccurrenceOptions" formulaire="vm.formulaireMtg" mono-occurrence-out="vm.monoOccurrence"> <ex-mono-occurrence-ecran-bas> <ex-card-saisie name="flg" formulaire="::vm.formulaireFlg"> </ex-card-saisie> </ex-mono-occurrence-ecran-bas> </ex-mono-occurrence-ecran> `;
// Exports
module.exports = code;